import { defineStore } from 'pinia';

// token 过期时间：7 天（毫秒）
const TOKEN_EXPIRE_MS = 7 * 24 * 60 * 60 * 1000;

export const useUserStore = defineStore('user', {
  state: () => ({
    userInfo: null,
    token: null,
    tokenTime: null,
  }),

  actions: {
    setUserInfo(info) {
      if (!info || !info.token) return;
      this.userInfo = info;
      this.token = info.token;
      this.tokenTime = Date.now();
      localStorage.setItem('userInfo', JSON.stringify(info));
      localStorage.setItem('token', info.token);
      localStorage.setItem('tokenTime', String(this.tokenTime));
    },

    clearUserInfo() {
      this.userInfo = null;
      this.token = null;
      this.tokenTime = null;
      localStorage.removeItem('userInfo');
      localStorage.removeItem('token');
      localStorage.removeItem('tokenTime');
    },

    // 判断 token 是否已过期
    isTokenExpired() {
      if (!this.token) return true;
      if (!this.tokenTime) return true;
      return Date.now() - this.tokenTime > TOKEN_EXPIRE_MS;
    },

    initUserInfo() {
      try {
        const userInfoStr = localStorage.getItem('userInfo');
        const token = localStorage.getItem('token');
        const tokenTimeStr = localStorage.getItem('tokenTime');

        if (!userInfoStr || !token) return;

        const userInfo = JSON.parse(userInfoStr);
        if (!userInfo || typeof userInfo !== 'object' || !userInfo.token) {
          throw new Error('userInfo 格式非法');
        }

        const tokenTime = tokenTimeStr ? Number(tokenTimeStr) : 0;
        // 校验 token 是否过期
        if (tokenTime && Date.now() - tokenTime > TOKEN_EXPIRE_MS) {
          this.clearUserInfo();
          return;
        }

        this.userInfo = userInfo;
        this.token = token;
        this.tokenTime = tokenTime || Date.now();
      } catch (e) {
        console.warn('解析 userInfo 失败，清除脏数据:', e?.message);
        this.clearUserInfo();
      }
    }
  }
}); 